export default {
  knowledgeApi: {
    search: 'api/knowledge/getList',
    esSearch: '/api/es/search',
    knowledge: {
      getVerifyStatusOptions: 'api/knowledge/getVerifyStatusOptions',
      getKnowledgeStatusOptions: 'api/knowledge/getKnowledgeStatusOptions',
      getListByPage: 'api/knowledge/getListByPage',
      saveOrUpdate: 'api/knowledge/saveOrUpdate',
      approve: 'api/knowledge/approve',
      changeKnowledgeStatus: 'api/knowledge/changeKnowledgeStatus',
      getDetail: 'api/knowledge/getDetail',
      getApproveLogs: 'api/knowledge/getApproveLogs',
    },
    category: {
      categoryTree: 'api/knowledge/category/categoryTree',
      addCategory: 'api/knowledge/category/addCategory',
      updateCategory: 'api/knowledge/category/updateCategory',
      delCategory: 'api/knowledge/category/delCategory',
    },
    tag: {
      tagOptions: 'api/knowledge/tag/tagOptions',
      pageList: 'api/knowledge/tag/pageList',
      saveOrUpdate: 'api/knowledge/tag/saveOrUpdate',
      delTag: 'api/knowledge/tag/delTag',
    },
  }
}
